/**
 * WordPress dependencies
 */
import { Circle, Rect, SVG } from '@wordpress/primitives';

export const patreon = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 569 546">
		<Circle cx="363" cy="205" r="205" />
		<Rect width="100" height="546" x="0" y="0" />
	</SVG>
);
